import styled from 'styled-components';

const StyledToast = styled.div`
  position: absolute;
  right: 10px;
  width: 40%;
  z-index: 200;
  padding-top: 0.2rem;
`;

export default StyledToast;
